module.exports = __webpack_public_path__ + "static/media/6 1 Ordforstaelse Intro.662a1e36.mp3";